<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="6"
                lg="8"
                md="8"
                sm="6"
            >
                <h3>Product</h3>
            </v-col>
            <v-col 
                style="text-align: right;"
                cols="6"
                lg="4"
                md="4"
                sm="6"
            >
                <input
                    ref="importExcelFile"
                    type="file"
                    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    style="display: none;"
                    @change="importExcel"
                />

                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            :loading="importing"
                            @click="$refs.importExcelFile.click()"
                            style="margin-right: 20px;"
                        >
                            <span>Import Excel</span>
                        </v-btn>
                    </template>
                    <span>Import products from Excel</span>
                </v-tooltip>

                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="exportExcel()"
                            style="margin-right: 20px;"
                        >
                            <span>Export to Excel</span>
                        </v-btn>
                    </template>
                    <span>Export to Excel</span>
                </v-tooltip>

                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            :to="{ name: 'productForm', params: {id: 0} }"
                        >
                            New Product
                        </v-btn>
                    </template>
                    <span>New Product</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Quick Search"
                        prepend-inner-icon="mdi mdi-magnify"
                        single-line
                        outlined
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredSearch"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >
                    <template v-slot:item.action="{item}">
                        <ActionList 
                            :id="item.id" 
                            :link="'productForm'"
                            :showButtons="{
                                edit: true,
                                cancel: item.status === 1 ? true : false,
                                active: item.status === 0 ? true : false
                            }"
                            @confirmCancel="confirmCancel"
                            @confirmActive="confirmActive"
                        />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import ActionList from "@/components/Layout/ActionList";
    import ActionDialog from "@/components/Layout/ActionDialog";
    import { URL_EXPORT_PRODUCT } from "@/utilities/Enums";

    export default ({

        components: {
            ActionList: ActionList,
            ActionDialog: ActionDialog
        },

        mixins: [Helpers],

        data: () => ({

            loading: false,
            importing: false,

            filter: {
                fastSearch: ''
            },

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            headers: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Category / Sub Category", value: "categoryAndSubCategoryDescription", sortable: true },
                { text: "Name", value: "description", sortable: true },
                { text: "Description", value: "details", sortable: true },
                { text: "Price", value: "priceFormatted", sortable: true },
                { text: "Order", value: "order", sortable: true },
                { text: "Color Selection", value: "colorSelectionDescription", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            options: { rowsPerPage: 10, page: 1 },

            listProduct: [],

            URL_EXPORT_PRODUCT
        }),

        computed: {

            filteredSearch: function() {
                return this.listProduct.filter((productFilter) => {
                    
                    const filter = this.filter.fastSearch.toLowerCase();

                    const dateRegisterFormatted = productFilter.dateRegisterFormatted.toLowerCase().match(filter)
                    const description = productFilter.description.toLowerCase().match(filter)
                    const details = productFilter.details != null ? productFilter.details.toLowerCase().match(filter) : ''
                    const categoryAndSubCategoryDescription = productFilter.categoryAndSubCategoryDescription.toLowerCase().match(filter)
                    const id = productFilter.id.toString().match(filter);
                    const priceFormatted = productFilter.priceFormatted.toLowerCase().match(filter)
                    const order = productFilter.order.toString().toLowerCase().match(filter)
                    const statusDescription = productFilter.statusDescription.toLowerCase().match(filter)
                    const colorSelectionDescription = productFilter.colorSelectionDescription.toLowerCase().match(filter)

                    if(dateRegisterFormatted != null) { return dateRegisterFormatted; } 
                    else if(description != null) { return description; } 
                    else if(details != null) { return details; } 
                    else if(categoryAndSubCategoryDescription != null) { return categoryAndSubCategoryDescription; } 
                    else if(id != 0) { return id; }
                    else if(priceFormatted != null) { return priceFormatted; } 
                    else if(order != null) { return order; } 
                    else if(statusDescription != null) { return statusDescription; }
                    else { return colorSelectionDescription; }
                });
            }
        },

        methods: {
            
            async getRegisters() {
                this.showLoading();
                this.listProduct = await this.$store.dispatch("productModule/List");
                this.hideLoading();
            },

            confirmCancel(id) {

                this.statusId = 0;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will INACTIVATE this Product, confirm your decision?',
                    methodConfirm: this.cancel,
                    params: id
                };
            },

            async cancel(id) {

                const statusId = this.statusId;

                this.showLoading();

                const result = await this.$store.dispatch("productModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            confirmActive(id) {

                this.statusId = 1;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will ACTIVATE this Product, confirm your decision?',
                    methodConfirm: this.active,
                    params: id
                };

            },

            async active(id) {

                this.showLoading();

                const statusId = this.statusId;

                const result = await this.$store.dispatch("productModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            async exportExcel() {
                this.exportFileName(this.URL_EXPORT_PRODUCT, null, 'ProductList.xlsx');
            },

            async importExcel(event) {
                this.showLoading();
                const file = event.target.files[0];

                if (!file) {
                    this.hideLoading();
                    return;
                }

                this.importing = true;
                const result = await this.$store.dispatch("productModule/ImportExcel", file);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                    await this.getRegisters();
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.importing = false;
                this.hideLoading();
                event.target.value = "";
            },
        },

        async created() {
            await this.getRegisters();
        }
    })
</script>
